import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { RouteEnum } from '@app/constants/route.enum';
import { AppStore } from '@app/stores/app.store';

export const featureGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const appStore = inject(AppStore);
  const currentPath = '/' + route.path;
  if (currentPath.includes(RouteEnum.OUR_FARM) && !appStore.featureToggles().farmVisitEnabled) {
    return router.createUrlTree([RouteEnum.NOT_FOUND]);
  }
  if (
    currentPath.includes(RouteEnum.TEST_REPORTS) &&
    !appStore.featureToggles().testReportEnabled
  ) {
    return router.createUrlTree([RouteEnum.NOT_FOUND]);
  }
  return true;
};
